import React, { useEffect, useState } from 'react';
import {
  Box,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
} from '@mui/material';
import '../styles/rangeDenomination.css';
import { handleAmount } from '../../../shared/extra';
import { addNewDenomination } from '../../../store/productDetails/action';
import { useDispatch, useSelector } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';

const RangeDenomination = () => {
  const PRODUCTDETAILS = useSelector(
    (state) => state.ProductDetail?.allData
  );

  const DENOMINATION_STORE_DATA = useSelector(
    (state) => state.Denominations?.allData
  );

  const dispatch = useDispatch();

  const [inputError, setInputError] = useState(false);
  const [inputErrorMessage, SetInputErrorMessage] = useState('');
  const [userAmt, setUserAmt] = useState('');

  // RANGE DATA
  const rangeData = PRODUCTDETAILS?.denominations?.find(
    (d) => d.type === 'RANGE'
  );
  const discountValues = rangeData?.userProductDenominationDiscounts?.[0]?.discountValue;

  // HANDLE ADD DENOMINATION
  const handleRangeDenomination = () => {
    const amount = Number(userAmt);

    if (
      amount >= Number(rangeData?.minAmount) &&
      amount <= Number(rangeData?.maxAmount)
    ) {
      const amtStatus = checkDuplicateDenomination();

      if (amtStatus) {
        handleRangeDenominationData();
      } else {
        setInputError(true);
        SetInputErrorMessage('Duplicate Denomination Amount!');
      }
    } else {
      setInputError(true);
      SetInputErrorMessage(
        `Denomination must be between ${handleAmount(
          rangeData?.minAmount
        )} AED and ${handleAmount(rangeData?.maxAmount)} AED`
      );
    }
  };

  // HANDLE INPUT
  const handleRangeInput = (e) => {
    const rawValue = e?.target?.value;

    // ONLY DIGITS
    const onlyDigits = rawValue.replace(/\D/g, '');

    const numericValue = Number(onlyDigits);

    // MAX VALIDATION
    if (numericValue > Number(rangeData?.maxAmount)) {
      setInputError(true);
      SetInputErrorMessage(
        `Denomination max limit ${handleAmount(
          rangeData?.maxAmount
        )} AED`
      );

      setUserAmt(0);
      return;
    }

    setUserAmt(onlyDigits);

    if (inputError) {
      setInputError(false);
      SetInputErrorMessage('');
    }
  };

  // ADD DATA TO STORE
  function handleRangeDenominationData() {
    const productId = PRODUCTDETAILS?.id;

    if (productId) {
      const denominationObject = {
        AMOUNT: Number(userAmt),
        DISCOUNT: Number(discountValues) || Number(rangeData?.value || 0),
        DISCOUNT_TYPE: rangeData?.cashbackOrDiscount,
        QUANTITY: 1,
        TOTAL: Number(userAmt),
        MAX_LIMIT: PRODUCTDETAILS?.max_quantity || 5,
        DENOM_TYPE: 'RANGE',
        PRODUCT_CODE: null,
        PRODUCT_GUID: null,
        PRODUCT_ID: PRODUCTDETAILS?.id,
        SUB_PRODUCT_ID: null,
        SKU_ID: null,
        ISCASHBACK_PRODUCT:
          PRODUCTDETAILS?.isCashbackProduct || false,
        PRODUCT_TYPE: PRODUCTDETAILS?.productType || null,
        CASHBACK_AMOUNT: null,
        DENOMINATION_ID: rangeData?.id || null,
      };

      dispatch(addNewDenomination(denominationObject));

      setUserAmt('');
    }
  }

  // CHECK DUPLICATE
  function checkDuplicateDenomination() {
    if (DENOMINATION_STORE_DATA?.length > 0) {
      const amounts = DENOMINATION_STORE_DATA?.map(
        (item) => Number(item.AMOUNT)
      );

      const occurrences = amounts.filter(
        (itemAmount) => itemAmount === Number(userAmt)
      ).length;

      return occurrences < 1;
    }

    return true;
  }

  useEffect(() => {
    if (inputError) {
      setTimeout(() => {
        setInputError(false);
        SetInputErrorMessage('');
      }, 2000);
    }
  }, [inputError]);

  return (
    <Grid
      container
      sx={{
        width: {
          xs: '100%',
          sm: '100%',
          lg: '100%',
        },
        px: 1,
        my: {
          lg: 1,
        },
        py: { sm: 2, lg: 0 },
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 2,
      }}
    >
      <Grid item xs={12} lg={12}>
        <Box

          sx={{
            py: { lg: 0 },
            px: { lg: 1 },
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            width: "100%",
            gap: 1,
            justifyContent: { lg: "center" },
            minHeight: {
              xs: "80px",
              sm: "65px",
              lg: "90px",
            },
          }}
        >
          <TextField
            variant="standard"
            placeholder={`${handleAmount(
              rangeData?.minAmount
            )} AED to ${handleAmount(rangeData?.maxAmount)} AED`}
            inputProps={{
              maxLength:
                rangeData?.maxAmount?.toString()?.length + 1,

              sx: {
                py: { xs: "14px", sm: "12px", lg: "10px" },

                fontSize: {
                  xs: "1rem",
                  sm: "1.2rem",
                  lg: "2rem",
                },

                letterSpacing: {
                  xs: "2px",
                  sm: "4px",
                  lg: "6px",
                },

                color: "primary.main",
              },
            }}
            value={userAmt ? handleAmount(userAmt) : ""}
            onChange={handleRangeInput}
            fullWidth
            sx={{
              width: "100%",

              "& .MuiInputBase-root": {
                width: "100%",
              },

              "& .MuiInputBase-input": {
                width: "100%",
              },
            }}
            error={inputError}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="add denomination"
                    onClick={handleRangeDenomination}
                    edge="end"
                    sx={{
                      backgroundColor: "primary.main",
                      color: "white.main",
                      width: {
                        xs: 38,
                        sm: 42,
                      },
                      height: {
                        xs: 38,
                        sm: 42,
                      },

                      "&:hover": {
                        backgroundColor: "primary.main",
                      },
                    }}
                  >
                    <AddIcon />
                  </IconButton>
                </InputAdornment>
              ),

              sx: {
                borderRadius: 6,
                pr: 1,
              },
            }}
          />

          <FormHelperText
            sx={{
              width: "100%",
              display: "block",
              mt: 1,
              lineHeight: 1.5,
              whiteSpace: "normal",
              wordBreak: "break-word",
              fontSize: {
                xs: "10px",
                sm: "11.5px",
              },

              color: inputErrorMessage
                ? "error.main"
                : "primary.main",

              fontWeight: 500,
            }}
          >
            {inputErrorMessage ||
              `Denominations must range from ${handleAmount(
                rangeData?.minAmount
              )} AED to ${handleAmount(
                rangeData?.maxAmount
              )} AED`}
          </FormHelperText>
        </Box>
      </Grid>
    </Grid>
  );
};

export default RangeDenomination;